"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _utils = require("@alycecom/utils");

var _reactRedux = require("react-redux");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _commonData = require("../../../Shared/store/commonData");

var _features = require("../../../Shared/store/features");

var _HasFeature = _interopRequireDefault(require("../../../hocs/HasFeature/HasFeature"));

var _CountriesPicker = require("../../../Shared/components/CountriesPicker");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      zIndex = _ref.zIndex;
  return {
    form: {
      position: 'relative'
    },
    textField: {
      marginTop: spacing(1),
      marginBottom: spacing(1)
    },
    popper: {
      zIndex: zIndex.modal,
      maxWidth: '100%',
      width: '100%'
    },
    countryButtonWrapper: {
      marginTop: spacing(1),
      marginBottom: spacing(1)
    },
    countryValueLabel: {
      color: palette.text.primary
    },
    countryErrorLabel: {
      marginTop: 0
    }
  };
});

var RecipientDetailsForm = function RecipientDetailsForm(_ref2) {
  var onSubmit = _ref2.onSubmit,
      onUpdateSearchField = _ref2.onUpdateSearchField,
      onUpdateField = _ref2.onUpdateField,
      recipient = _ref2.recipient,
      renderActions = _ref2.renderActions,
      onSelectContact = _ref2.onSelectContact,
      onClearSearch = _ref2.onClearSearch,
      disabled = _ref2.disabled,
      errors = _ref2.errors,
      contacts = _ref2.contacts,
      isContactsLoading = _ref2.isContactsLoading,
      _ref2$disabledFields = _ref2.disabledFields,
      disabledFields = _ref2$disabledFields === void 0 ? {} : _ref2$disabledFields,
      _ref2$hasInternationa = _ref2.hasInternational,
      hasInternational = _ref2$hasInternationa === void 0 ? false : _ref2$hasInternationa,
      _ref2$campaignId = _ref2.campaignId,
      campaignId = _ref2$campaignId === void 0 ? undefined : _ref2$campaignId;
  var classes = useStyles();
  var customFields = (0, _reactRedux.useSelector)(_commonData.CommonData.selectors.getCustomFields);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var countries = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return campaign ? _commonData.CommonData.selectors.makeGetCountriesByIds(campaign.countryIds) : _commonData.CommonData.selectors.makeGetAvailableCountries(hasInternational);
  }, [hasInternational, campaign]));
  var country = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    var countryId = campaign && campaign.countryIds.length === 1 ? campaign.countryIds[0] : recipient.country;
    return _commonData.CommonData.selectors.makeGetCountryById(countryId, null);
  }, [recipient, campaign]));

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showMore = _useState2[0],
      setShowMore = _useState2[1];

  var handleShowMoreInfo = (0, _react.useCallback)(function () {
    return setShowMore(!showMore);
  }, [showMore]);
  var hasErrors = (0, _utils.hasKeys)(errors);
  var enableExtraFields = !!customFields.length || hasErrors;
  (0, _react.useEffect)(function () {
    setShowMore(enableExtraFields);
  }, [enableExtraFields, setShowMore]);
  var handleSearchInputChange = (0, _react.useCallback)(function (event) {
    var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
    onUpdateSearchField(name, value);
  }, [onUpdateSearchField]);
  var handleChangeCountry = (0, _react.useCallback)(function (value) {
    if (value) {
      onUpdateField({
        country: value.id
      });
    }
  }, [onUpdateField]);
  var handleSelectEmail = (0, _react.useCallback)(function (contact) {
    if (contact) {
      onSelectContact(contact);
    }
  }, [onSelectContact]);
  var handleChangeSearchEmail = (0, _react.useCallback)(function (email) {
    if (email && (email === null || email === void 0 ? void 0 : email.length) < recipient.email.length || !email) {
      onClearSearch();
    }
  }, [recipient, onClearSearch]);
  var isMount = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (country && !isMount.current) {
      onUpdateField({
        country: country.id
      });
      isMount.current = true;
    }
  }, [country, onUpdateField]);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: classes.form,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Autocomplete, {
    options: contacts,
    fullWidth: true,
    loading: isContactsLoading,
    inputValue: recipient.email,
    onChange: function onChange(_, contact) {
      return handleSelectEmail(contact);
    },
    onInputChange: function onInputChange(_, email) {
      return handleChangeSearchEmail(email);
    },
    getOptionLabel: function getOptionLabel(option) {
      return option ? option.email : '';
    },
    clearOnBlur: false,
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/_react.default.createElement(_material.Typography, (0, _extends2.default)({}, props, {
        "data-testid": "RecipientDetailsForm.Autocomplete.".concat(option.email)
      }), option.email);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, params, {
        label: "Work email",
        name: "email",
        onChange: handleSearchInputChange,
        error: !!(errors && errors.email),
        helperText: errors === null || errors === void 0 ? void 0 : errors.email
      }));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.TextField, {
    className: classes.textField,
    label: "First name",
    fullWidth: true,
    value: recipient.firstName || '',
    error: !!(errors && errors.first_name),
    helperText: errors && errors.first_name,
    disabled: disabled || disabledFields.firstName,
    name: "firstName",
    onChange: handleSearchInputChange
  }), /*#__PURE__*/_react.default.createElement(_material.TextField, {
    className: classes.textField,
    label: "Last name",
    fullWidth: true,
    value: recipient.lastName || '',
    error: !!(errors && errors.last_name),
    helperText: errors && errors.last_name,
    disabled: disabled || disabledFields.lastName,
    name: "lastName",
    onChange: handleSearchInputChange
  }), /*#__PURE__*/_react.default.createElement(_material.TextField, {
    className: classes.textField,
    label: "Company name",
    fullWidth: true,
    error: !!(errors && errors.employment),
    helperText: errors && errors.employment,
    disabled: disabled || disabledFields.employment,
    value: recipient.employment || '',
    name: "employment",
    onChange: handleSearchInputChange
  }), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: !!(errors && errors.country_id),
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_CountriesPicker.CountriesPicker, {
    label: "Recipient country",
    searchLabel: "Search country",
    name: "country",
    value: country,
    onChange: handleChangeCountry,
    options: countries,
    multiple: false,
    classes: {
      popper: classes.popper,
      buttonWrapper: classes.countryButtonWrapper,
      valueLabel: classes.countryValueLabel
    },
    disabled: disabled || disabledFields.countryId,
    buttonIconProps: {
      fontSize: 0.8
    },
    listboxProps: {
      maxVisibleRows: 4
    }
  }), !!errors && errors.country_id && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    className: classes.countryErrorLabel
  }, errors.country_id))), /*#__PURE__*/_react.default.createElement(_HasFeature.default, {
    featureKey: _features.Features.FLAGS.CAN_USE_CUSTOM_FIELDS
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: showMore,
    unmountOnExit: true
  }, customFields.map(function (_ref3) {
    var _errors$name, _recipient$customFiel;

    var label = _ref3.label,
        name = _ref3.name;
    return /*#__PURE__*/_react.default.createElement(_material.TextField, {
      className: classes.textField,
      key: name,
      fullWidth: true,
      error: !!(errors !== null && errors !== void 0 && errors[name]),
      helperText: (_errors$name = errors === null || errors === void 0 ? void 0 : errors[name]) !== null && _errors$name !== void 0 ? _errors$name : '',
      label: label,
      value: (recipient === null || recipient === void 0 ? void 0 : (_recipient$customFiel = recipient.customFields) === null || _recipient$customFiel === void 0 ? void 0 : _recipient$customFiel[name]) || '',
      variant: "outlined",
      onChange: function onChange(e) {
        return onUpdateField({
          customFields: _objectSpread(_objectSpread({}, recipient.customFields), {}, {
            [name]: e.target.value
          })
        });
      }
    });
  })), customFields.length > 0 && /*#__PURE__*/_react.default.createElement(_material.Box, {
    position: "absolute",
    bottom: 16
  }, /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
    onClick: handleShowMoreInfo
  }, "Show ", showMore ? 'less' : 'more', " info")))), renderActions());
};

var _default = /*#__PURE__*/(0, _react.memo)(RecipientDetailsForm);

exports.default = _default;